<template>
    <label class="text-gray-800 text-sm">{{ $t("airtable.forms.airtable_record.title") }}</label>
    <p class="text-gray-800 text-xs">{{ $t("airtable.forms.airtable_record.description") }}</p>
    <select-menu
        :content="data.records"
        :key-name="keyName"
        :title="$t('airtable.forms.airtable_record.title')"
        :searchable="true"
        @SearchInput="searchOnInput"
        @SelectItem="SelectedItem"
    ></select-menu>
    <div v-if="!data.records.length">
        <p class="my-2 text-gray-300 text-center">{{ $t("airtable.no_records_found") }}</p>
    </div>
</template>

<script>
import { reactive } from "vue";
import SelectMenu from "@/Components/SelectMenu";

export default {
    name: "AirtableSelector",
    components: {
        SelectMenu,
    },
    props: {
        type: String,
        errors: {
            type: [Array, Boolean],
            required: false,
        },
        selected: {
            type: String,
            required: false,
        },
        preSelectedId: {
            type: String,
            required: false,
        },
        keyName: String,
        searchable: Boolean,
    },
    emits: ["input"],
    setup(props, { emit }) {
        const data = reactive({
            records: {},
            selected: props.selected,
        });

        axios.get(route(`airtable.${props.type}`)).then((response) => {
            data.records = response.data;
        });

        const searchOnInput = (value) => {
            const form = new FormData();
            form.append("type", props.type);
            form.append("key", value);

            axios.post(route("airtable.search"), form).then((response) => {
                data.records = response.data;
            });
        };

        const SelectedItem = (item) => {
            emit("input", item.id);
        };

        return { data, searchOnInput, SelectedItem };
    },
};
</script>
